import script from "./UserSignin.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSignin.vue?vue&type=script&setup=true&lang=js"

import "./UserSignin.vue?vue&type=style&index=0&id=2bf56727&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf56727"]])

export default __exports__